import { Injectable } from "@angular/core";
import { Util } from "src/app/util";
import type { FilterSearch } from "./models/filters-search.model";
import type { FilterGroup } from "./models/filters-search.response";

@Injectable({
  providedIn: 'root',
})
export class FiltersSearchFactory {
  buildSearchFilters(group: FilterGroup): FilterSearch {
    const isFormatFilter = group.value === Util.FORMAT_FILTER;

    return {
      ...group,
      filterItems: group.filterItems.map((filter) => {
        const icon = Util.resolveIcon(filter.value);

        return {
          ...filter,
          label: isFormatFilter ? icon.label : filter.label,
          icon,
          selected: false,
        };
      }),
    };
  }
}
